module.exports = __webpack_public_path__ + "img/3.6d8f21bd.jpg";